import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../../Componets/Header";
import forms from "../../../../../Data/Forms/Tax/Tax_Types/forms";
import headers from "../../../../../Data/Forms/Tax/Tax_Types/headers";
import Loadercomponent from "../../../../../Componets/Loader";
import {
  create_tax_type,
  get_tax_type,
  update_tax_type,
  get_all_tax_types
} from "../../../../../Controllers/Tax/Tax_Types";

const TaxTypeForm = ({ isModal = false, onClose }) => {
  const params = useParams();
  const id = isModal ? null : params.id;

  const [header, setHeader] = useState(headers);

  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const taxType = id
        ? await update_tax_type({ id: id, ...data?.data })
        : await create_tax_type(data?.data);

      if (taxType?.status) {
        if (isModal) {
          onClose && onClose();
        } else {
          navigate(-1);
        }
        toast?.success(taxType?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (taxType?.status_code == 403) {
          window.location.href = "/unauthorized";
        } else {
          toast?.error(taxType?.message);
        }

      }
    }
  };

  const handleData = (taxType) => {

    let status = taxType?.status ? taxType?.status : 0;

    forms[0].options[0].form.value = taxType?.name || "";
    forms[0].options[1].form.value = taxType?.code || "";
    forms[0].options[2].form.value = taxType?.description || "";

    forms[1].options[0].form.value = status;

    setLoader(false);
    setValues([...forms]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const taxType = await get_tax_type(data);


      if (taxType?.status) {
        handleData(taxType?.data);
      } else {
        toast?.error(taxType?.message);
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();

  }, [id]);

  const content = (
    <Loadercomponent loader={loader}>
      <Forms
        form={values}
        setForm={setValues}
        formdata={formdata}
        buttonLoader={buttonLoader}
        isModal={isModal}
        onModalClose={onClose}
      />
    </Loadercomponent>
  );
  return isModal ? (
    content
  ) : (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      {content}
    </Header>
  );
};

export default TaxTypeForm;